export default "__VITE_ASSET__VIvF9vFl__"